import { faker } from "@faker-js/faker";

import { merge } from "@/__mocks__/mockHelpers";

interface FuseSearchMockObject {
  day: string;
  description: string;
  host: string;
  title: string;
}

const fakeFuseSearchObject = (
  overrides?: DeepPartial<FuseSearchMockObject>,
): FuseSearchMockObject => {
  const searchObject: FuseSearchMockObject = {
    day: faker.date.weekday(),
    description: faker.lorem.sentence(),
    host: faker.internet.email(),
    title: faker.lorem.words(),
  };
  return merge(searchObject, overrides);
};

export type { FuseSearchMockObject };
export { fakeFuseSearchObject };
